import { Text } from "~/components/Text";

interface OfficeInformationProps {
  email?: string | null;
  phone?: string | null;
}

export function OfficeInformation({ email, phone }: OfficeInformationProps) {
  return (
    <div className="p-sm text-center" data-component="TimetableOfficeInfo">
      <div className="text-gray-500">
        {phone && email ? (
          <Text
            components={{ phone: <Phone phone={phone} />, email: <Email email={email} /> }}
            i18nKey="steps.Timetable.ContactInfo.information_phone_email"
          />
        ) : phone ? (
          <Text
            components={{ phone: <Phone phone={phone} /> }}
            i18nKey="steps.Timetable.ContactInfo.information_phone"
          />
        ) : email ? (
          <Text
            components={{ email: <Email email={email} /> }}
            i18nKey="steps.Timetable.ContactInfo.information_email"
          />
        ) : (
          <Text i18nKey="steps.Timetable.ContactInfo.information_none" />
        )}
      </div>
    </div>
  );
}

export function EditOfficeInformation({ email, phone }: OfficeInformationProps) {
  return (
    <div className="p-sm text-center" data-component="EditOfficeInfo">
      <div className="text-gray-500">
        {phone && email ? (
          <Text
            components={{ phone: <Phone phone={phone} />, email: <Email email={email} /> }}
            i18nKey="Edit.ContactInfo.information_phone_email"
          />
        ) : phone ? (
          <Text
            components={{ phone: <Phone phone={phone} /> }}
            i18nKey="Edit.ContactInfo.information_phone"
          />
        ) : email ? (
          <Text
            components={{ email: <Email email={email} /> }}
            i18nKey="Edit.ContactInfo.information_email"
          />
        ) : (
          <Text i18nKey="Edit.ContactInfo.information_none" />
        )}
      </div>
    </div>
  );
}

function Email({ email }: { email: string }) {
  return (
    <a className="text-brand underline" href={`mailto:${email}`} rel="noreferrer" target="_blank">
      {email}
    </a>
  );
}

function Phone({ phone }: { phone: string }) {
  return (
    <a className="text-brand underline" href={`tel:${phone}`} rel="noreferrer" target="_blank">
      {phone}
    </a>
  );
}
